import { z } from 'zod';
import { optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
export const workOrderComponentInputSchema = z.object({
    partId: requiredUuidString('Component is required.', 'Invalid component selection.'),
    qtyTarget: z
        .number()
        .positive('Quantity target must be greater than zero.')
        .max(1_000_000_000, 'Quantity target must be 1,000,000,000 or less.'),
    uomId: optionalUuidString('Invalid unit of measure selection.')
        .nullish()
        .transform((value) => (value == null || value.trim() === '' ? undefined : value))
        .optional(),
    name: z
        .string()
        .trim()
        .min(1, 'Line name is required.')
        .max(256, 'Line name must be 256 characters or fewer.'),
});
//# sourceMappingURL=component-input.js.map